/**
 * paopao-checkout-guard.js — site-wide pre-checkout stock check for custom pieces.
 *
 * On any "Checkout" action it asks the paopao-stock-check section whether every custom
 * piece (lines sharing a `_build` property) can still be fulfilled from live stock. If a
 * piece is short it shows a popup with "Remove from my bag" / "Edit my custom piece" —
 * both remove the piece's lines from the cart; Edit reopens it in the configurator.
 *
 * Fail-open: if the check can't run, checkout proceeds (never block a sale on our error).
 */
(function () {
  var CONFIGURATOR_URL = '/pages/custom'; // where the configurator section lives
  var DEBUG = false;                       // set true to log diagnostics to the console
  var log = function () { if (DEBUG && window.console) console.info.apply(console, ['[paopao-guard]'].concat([].slice.call(arguments))); };
  var proceeding = false;
  var modalOpen = false;

  log('loaded');

  // Does this element (or an ancestor) trigger checkout?
  function checkoutEl(target) {
    if (!target || !target.closest) return null;
    var a = target.closest('a[href]');
    if (a && /\/checkout(\b|\/|\?|$)/.test(a.getAttribute('href') || '')) return a;
    var b = target.closest('button[name="checkout"], input[name="checkout"], [data-checkout], .cart-drawer__checkout, #checkout, .cart__checkout');
    if (b) return b;
    return null;
  }

  function fetchStock() {
    return fetch('/?sections=paopao-stock-check', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        // Section Rendering wraps output in <div class="shopify-section">…</div>; the JSON
        // is the div's text content.
        var raw = String((d && d['paopao-stock-check']) || '');
        var tmp = document.createElement('div');
        tmp.innerHTML = raw;
        var text = (tmp.textContent || raw).trim();
        log('stock-check json:', text);
        try { return JSON.parse(text); } catch (e) { log('parse failed', e); return null; }
      })
      .catch(function (e) { log('fetch failed', e); return null; });
  }

  function firstShort(data) {
    if (!data || !data.groups) return null;
    for (var i = 0; i < data.groups.length; i++) if (!data.groups[i].ok) return data.groups[i];
    return null;
  }

  function removeGroup(keys) {
    var updates = {};
    String(keys || '').split(',').forEach(function (k) { if (k) updates[k] = 0; });
    log('removing keys', updates);
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    });
  }

  function goCheckout() { proceeding = true; log('proceeding to checkout'); window.location.href = '/checkout'; }

  function showPopup(group) {
    if (modalOpen) return;
    modalOpen = true;
    log('blocking — short piece', group);
    var backdrop = document.createElement('div');
    backdrop.className = 'fixed inset-0 z-[9999] flex items-center justify-center bg-black/30';
    backdrop.innerHTML =
      '<div class="bg-background rounded-sm shadow-lg px-3 py-4 md:px-4 md:py-6 max-w-[420px] mx-4 text-center">' +
        '<h4 class="h4 m-0 mb-2 uppercase">Some parts of your custom piece are sold out</h4>' +
        '<p class="p m-0 mb-5 text-foreground/70">Some pieces or charms in your custom piece are no longer available.</p>' +
        '<div class="flex items-center justify-center gap-3">' +
          '<button data-act="remove" class="btn btn--secondary shadow-[inset_0_0_0_1px_var(--color-secondary-button-text)] text-secondary-button-text text-sm px-4 pt-2.25 pb-2 leading-none rounded-xs font-semibold uppercase cursor-pointer">Remove from bag</button>' +
          '<button data-act="edit" class="btn btn--primary bg-button text-button-text text-sm px-4 pt-2.25 pb-2 leading-none rounded-xs font-semibold uppercase cursor-pointer">Edit custom piece</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(backdrop);

    function close() { backdrop.remove(); modalOpen = false; }
    backdrop.addEventListener('click', function (e) { if (e.target === backdrop) close(); });
    backdrop.querySelector('[data-act="remove"]').addEventListener('click', function () {
      removeGroup(group.keys).then(function () { close(); runGuard(); }); // re-check remaining, then proceed
    });
    backdrop.querySelector('[data-act="edit"]').addEventListener('click', function () {
      removeGroup(group.keys).then(function () {
        window.location.href = CONFIGURATOR_URL + '?edit=' + encodeURIComponent(group.build);
      });
    });
  }

  function runGuard() {
    fetchStock().then(function (data) {
      var g = firstShort(data);
      if (!g) { goCheckout(); return; } // all good (or check failed → fail-open)
      showPopup(g);
    });
  }

  // Click on a checkout link/button.
  document.addEventListener('click', function (e) {
    if (proceeding || modalOpen) return;
    var el = checkoutEl(e.target);
    if (!el) return;
    log('intercepted checkout click', el);
    e.preventDefault();
    e.stopPropagation();
    runGuard();
  }, true);

  // Form submit that ends at checkout (cart page: <form action="/cart"> with name="checkout",
  // or <form action="/checkout">).
  document.addEventListener('submit', function (e) {
    if (proceeding || modalOpen) return;
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = (form.getAttribute('action') || '');
    var submitter = e.submitter || form.querySelector('[type="submit"][name="checkout"], button[name="checkout"]');
    var isCheckout = /\/checkout/.test(action) || (submitter && submitter.name === 'checkout');
    if (!isCheckout) return;
    log('intercepted checkout submit', form);
    e.preventDefault();
    e.stopPropagation();
    runGuard();
  }, true);
})();
